<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/customer/table">客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">{{$route.meta.title}}</template>
      <el-table :data="table"
                stripe
                highlight-current-row
                :show-header="false"
                class="margin b15"
                style="width: 100%">
        <el-table-column width="150">
          <template slot-scope="scope">
            <b>{{scope.row.label}}</b>
          </template>
        </el-table-column>
        <el-table-column min-width="150">
          <template slot-scope="scope">
            <div>{{scope.row.value}}</div>
          </template>
        </el-table-column>
      </el-table>
      <router-link to="/customer/table">
        <el-button type="primary">返回</el-button>
      </router-link>
      <router-link :to="`/customer/balance-flow/${id}`">
        <el-button type="primary">客户消费记录</el-button>
      </router-link>
    </layout-panel>
  </div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  data () {
    return {
      table: [
        {
          key: 'id',
          label: '客户ID',
          value: '',
        },
        {
          key: 'number',
          label: '客户唯一编号',
          value: '',
        },
        {
          key: 'name',
          label: '客户名称',
          value: '',
        },
        {
          key: 'company',
          label: '客户公司',
          value: '',
        },
        {
          key: 'managementfees',
          label: '客户管理费率',
          value: '',
        },
        {
          key: 'balance',
          label: '客户当前余额',
          value: '',
        },
        {
          key: 'pendingfee',
          label: '客户当前冻结金额',
          value: '',
        },
        {
          key: 'totalspentmoney',
          label: '客户总消费金额',
          value: '',
        },
        {
          key: 'totaltasknum',
          label: '客户总投放任务',
          value: '',
        },
        {
          key: 'totalhirenum',
          label: '客户总雇佣人数',
          value: '',
        },
        {
          key: 'ongoingtasknum',
          label: '客户当前进行中的任务',
          value: '',
        },
      ],
    }
  },
  computed: Vuex.mapState({}),
  created () {
    this.id = this.$route.params.id
    this.id > 0 && this.setDetailData(this.id)
  },
  methods: {
    ...Vuex.mapActions([]),
    setDetailData (id) {
      request.page('getCustomerBalanceDetail', {id}).then(({data}) => {
        this.table.forEach(obj => {
          if (data[obj.key]) {
            obj.value = data[obj.key]

            if (obj.key === 'managementfees') {
              obj.value = parseFloat(obj.value) * 100 + '%'
            }

            if (obj.key === 'ongoingtasknum') {
              obj.value += ` (奖金总额: ${data.ongoingtaskmoney})`
            }

            if (obj.key === 'totalspentmoney') {
              obj.value += ` (管理费: ${data.totalmanagementfee})`
            }
          }
        })

        this.$store.commit('SELECTED_CUSTOMER_DETAIL', data)
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/customer/pages/CustomerDetail.vue